export { default } from './UnscoredCategoryPageSeo'
